import { toast } from "react-toastify";
import API from "../../Api/Api";
import { API_END_POINT } from "../../Api/EndPoints";

const errors = [
  "email must be a valid email",
  "password must be at least 6 characters",
  "Email or Username are already taken",
];

export const fetchTransporters =
  (page = 1, search = "", filters = {}, signal) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_TRANSPORTERS_LOADING" });
    try {
      const query = {
        pagination: {
          page: page,
          pageSize: 10,
        },
        populate: {
          deliveries: true,
          depots: true,
          user: true,
        },
        filters: {
          ...(search && {
            $or: [
              { name: { $containsi: search } },
              { phoneNumber: { $containsi: search } },
              {
                user: {
                  email: {
                    $containsi: search,
                  },
                },
              },
            ],
          }),
          ...filters,
        },
      };

      const { data } = await API.get(`${API_END_POINT}api/transporters`, {
        signal,
        params: query,
      });

      if (page === 1) {
        dispatch({
          type: "FETCH_TRANSPORTERS_SUCCESS",
          payload: {
            data: data?.data,
            meta: data?.meta,
          },
        });
      } else {
        dispatch({
          type: "FETCH_TRANSPORTERS_LOAD_MORE_SUCCESS",
          payload: {
            data: data?.data,
            meta: data?.meta,
          },
        });
      }
    } catch (error) {
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED")
        return;
      console.log(error);
      dispatch({ type: "FETCH_TRANSPORTERS_ERROR", payload: error });
    }
  };

export const fetchTransporterById = (id) => async (dispatch) => {
  dispatch({ type: "FETCH_TRANSPORTER_LOADING" });
  try {
    const params = {
      populate: {
        deliveries: true,
        depots: true,
        user: true,
      },
    };
    const { data } = await API.get(`${API_END_POINT}api/transporters/${id}`, {
      params,
    });
    dispatch({ type: "FETCH_TRANSPORTER_SUCCESS", payload: data?.data });
  } catch (error) {
    console.log(error);
    dispatch({ type: "FETCH_TRANSPORTER_ERROR", payload: error });
  }
};

export const refetchTransporter = (id) => async (dispatch) => {
  try {
    const params = {
      populate: {
        deliveries: true,
        depots: true,
        user: true,
      },
    };
    const { data } = await API.get(`${API_END_POINT}api/transporters/${id}`, {
      params,
    });

    dispatch({ type: "REFETCH_TRANSPORTER_SUCCESS", payload: data?.data });
  } catch (error) {
    console.log(error);
    dispatch({ type: "REFETCH_TRANSPORTER_ERROR", payload: error });
  }
};

export const createTransporter =
  (transporterData, t, closeModal) => async (dispatch, getState) => {
    const user = getState().userReducer?.user;
    dispatch({ type: "CREATE_TRANSPORTER_LOADING" });
    try {
      const userData = {
        marque: user?.attributes?.marque?.data?.id,
        username: transporterData.user.email,
        email: transporterData.user.email,
        password: transporterData.user.password,
        userRole: 4,
        confirmed: true,
        blocked: false,
      };

      const existingUser = await API.get(
        `${API_END_POINT}api/users?filters[email][$eq]=${transporterData.user.email}`,
      );

      if (existingUser?.data?.length > 0) {
        throw new Error("Email or Username are already taken");
      }

      const userResponse = await API.post(
        `${API_END_POINT}api/auth/local/register`,
        userData,
      );

      const transporterPayload = {
        name: transporterData.name,
        phoneNumber: transporterData.phoneNumber,
        user: userResponse.data.user.id,
        companyName: transporterData.companyName,
        companyPhoneNumber: transporterData.companyPhoneNumber,
        companyEmail: transporterData.companyEmail,
      };

      const createTransporter = await API.post(
        `${API_END_POINT}api/transporters`,
        {
          data: transporterPayload,
        },
      );

      const { data } = await API.get(
        `${API_END_POINT}api/transporters/${createTransporter?.data?.data?.id}`,
        {
          params: {
            populate: {
              deliveries: true,
              depots: true,
              user: true,
            },
          },
        },
      );
      dispatch({ type: "CREATE_TRANSPORTER_SUCCESS", payload: data?.data });
      closeModal();
      return data?.data;
    } catch (error) {
      if (
        errors?.includes(
          error?.response?.data?.error?.message || error?.message,
        )
      ) {
        toast.error(
          t(`${error?.response?.data?.error?.message || error?.message}`),
        );
      } else {
        toast.error(t("An error has occurred!"));
      }
      dispatch({ type: "CREATE_TRANSPORTER_ERROR", payload: error });
    }
  };

export const updateTransporter =
  (id, transporterData, t, closeModal) => async (dispatch) => {
    dispatch({ type: "UPDATE_TRANSPORTER_LOADING" });
    try {
      if (transporterData.user && transporterData.user.id) {
        const userData = {
          username: transporterData.user.email,
          email: transporterData.user.email,
        };

        if (transporterData.user?.password?.length > 0) {
          userData.password = transporterData.user?.password;
        }

        await API.put(
          `${API_END_POINT}api/users/${transporterData.user.id}`,
          userData,
        );
      }

      const transporterPayload = {
        name: transporterData.name,
        phoneNumber: transporterData.phoneNumber,
        companyName: transporterData.companyName,
        companyPhoneNumber: transporterData.companyPhoneNumber,
        companyEmail: transporterData.companyEmail,
      };

      await API.put(`${API_END_POINT}api/transporters/${id}`, {
        data: transporterPayload,
      });

      const { data } = await API.get(`${API_END_POINT}api/transporters/${id}`, {
        params: {
          populate: {
            deliveries: true,
            depots: true,
            user: true,
          },
        },
      });
      dispatch({ type: "UPDATE_TRANSPORTER_SUCCESS", payload: data?.data });
      closeModal();
      return data?.data;
    } catch (error) {
      dispatch({ type: "UPDATE_TRANSPORTER_ERROR", payload: error });
      if (errors?.includes(error?.response?.data?.error?.message)) {
        toast.error(t(`${error?.response?.data?.error?.message}`));
      } else {
        toast.error(t("An error has occurred!"));
      }
    }
  };

export const deleteTransporter = (id, t) => async (dispatch) => {
  dispatch({ type: "DELETE_TRANSPORTER_LOADING" });
  try {
    const { data: transporterData } = await API.get(
      `${API_END_POINT}api/transporters/${id}`,
      {
        params: {
          populate: {
            user: true,
          },
        },
      },
    );

    await API.delete(`${API_END_POINT}api/transporters/${id}`);

    const userId = transporterData?.data?.attributes?.user?.data?.id;
    if (userId) {
      await API.delete(`${API_END_POINT}api/users/${userId}`);
    }

    dispatch({ type: "DELETE_TRANSPORTER_SUCCESS", payload: id });
    return id;
  } catch (error) {
    dispatch({ type: "DELETE_TRANSPORTER_ERROR", payload: error });
    if (errors?.includes(error?.response?.data?.error?.message)) {
      toast.error(t(`${error?.response?.data?.error?.message}`));
    } else {
      toast.error(t("An error has occurred!"));
    }
  }
};

export const clearTransporterData = () => (dispatch) => {
  dispatch({ type: "CLEAR_TRANSPORTER_DATA" });
};
